"use client";
import { Dropdown, Navbar, Nav, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Brand from "./Brand";
import CustomToggle from "./Dropdown/CustomToggle";

const HeaderNavbar = ({ currentLanguage, setCurrentLanguage }) => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    if (setCurrentLanguage) setCurrentLanguage(lng);
  };

  return (
    <Navbar dark expand="lg" style={{
      padding: "20px 20px 20px 30px", marginTop: "20px", color: "black",
      borderRadius: "70px", border: "1px solid rgba(83, 97, 119, 0.20)",
      background: "#F3F8FF", marginBottom: "100px",
    }}>
      <Brand />
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mx-auto" style={{ color: "var(--Color-black, #232933)", fontFamily: "Montserrat", fontSize: "16px", fontWeight: "500" }}>
          <Nav.Link href="/">Home</Nav.Link>
          <Nav.Link href="/pricing">Pricing</Nav.Link>
          <Nav.Link href="/#features">Features</Nav.Link>
          <Nav.Link href="/blog">Tipps and Tricks</Nav.Link>
        </Nav>
        <Button variant="outline-primary" as="a" href="/login" style={{ marginRight: "10px", border: "none" }}>
          Log In
        </Button>
        <div className="btn-group">
          <Button variant="primary" as="a" href="/signup" style={{
            borderBottomLeftRadius: "50px", borderTopLeftRadius: "50px",
            border: "1px solid #5FD0F3", background: "#5FD0F3",
          }}>
            Sign Up
          </Button>
          <Dropdown style={{ float: "right", marginLeft: "-5px" }}>
            <Dropdown.Toggle id="dropdown-lang" as={CustomToggle} style={{ border: "none", boxShadow: "none" }} />
            <Dropdown.Menu style={{ borderRadius: 12, fontSize: 13, padding: "6px 4px", minWidth: 140, boxShadow: "0 4px 16px rgba(0,0,0,0.12)" }}>
              <Dropdown.Item onClick={() => changeLanguage("de")} style={{ borderRadius: 8, padding: "6px 12px" }}>
                <span className="fi fi-de fis" />&nbsp; {t("Translation.German")}
              </Dropdown.Item>
              <div className="dropdown-divider" />
              <Dropdown.Item onClick={() => changeLanguage("en")} style={{ borderRadius: 8, padding: "6px 12px" }}>
                <span className="fi fi-us fis" />&nbsp; {t("Translation.English")}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default HeaderNavbar;
